<h2 mat-dialog-title style="text-align: center">Dokument hinzufügen</h2>
<mat-dialog-content class="mat-typography">
  <div style="margin-bottom: 0.5rem">
    <mat-form-field style="width: 100%">
      <mat-label>Dokumenttyp</mat-label>
      <mat-select [(value)]="selectedType" [disabled]="isUploading">
        <mat-option *ngFor="let t of types" [value]="t">
          {{ t.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <app-input
    label="Dokumentname"
    [(value)]="fileName"
    [disabled]="isUploading"
    placeholder="Wenn leer dann wird Dateiname genommen"
  ></app-input>
  <br />
  <div>
    Dateiname: {{ selectedFile ? selectedFile : "Keine Datei ausgewählt" }}
  </div>
  <input
    type="file"
    style="display: none"
    (change)="onFileSelected($event)"
    #fileUpload
  />
  <button mat-button (click)="fileUpload.click()" [disabled]="isUploading">
    <mat-icon>attach_file</mat-icon>
    <span>Datei auswählen</span>
  </button>
<!--
  <div style="margin: 1rem 0;">
    <fieldset style="border-radius: 0.4rem;padding:4px 0 4px 1rem">
      <legend style="margin-left:0.5rem">Bildoptionen</legend>
      <app-image-scale-tray
        [resolutions]="imageResolutions"
        [types]="imageTypes"
        [selected-res-id]="imageResId"
        [selected-type-id]="imageTypeId"
        (res-change)="onResChange($event)"
        (type-change)="onTypeChange($event)"
      ></app-image-scale-tray>
    </fieldset>
  </div>
-->
  <app-upload-progress-bar
    *ngIf="isUploading"
    [data]="progressData"
  ></app-upload-progress-bar>
</mat-dialog-content>
<div mat-dialog-actions class="row-layout flex-content-end">
  <button mat-button (click)="close()">Abbrechen</button>
  <button mat-button style="margin-left: 1rem" (click)="save()">
    Speichern
  </button>
</div>
